export default "__VITE_ASSET__BPEZYd7C__"